import { types } from 'mobx-state-tree';


export default types
    .model('HomeCoverage', {
        // Standard values
        personalLiability: 2000000,
        claimsDeductible: 1000,
        sewerBackup: true,
        overlandWater: true,

        // BC values
        earthquake: types.maybeNull(types.boolean),
        strataDeductible: types.maybeNull(types.boolean),
    });
